<script setup lang="ts">
import { useRouter } from 'vue-router'
import { ISensorGroup } from '@/interfaces/stores/anomalyDetector'

const props = defineProps<{
    group: ISensorGroup
    type: 'attention' | 'critical'
}>()

const router = useRouter()

function handleClick() {
    router.push({
        name: 'anomalyDetectorDetails',
        params: { sensorId: String(props.group.sensorId) },
        query: { type: props.type },
    })
}
</script>

<template>
    <div
        class="rounded-none bg-white border border-stroke shadow-sm hover:shadow-md cursor-pointer transition-shadow duration-200 overflow-hidden relative"
        @click="handleClick"
    >
    <span :class="type === 'critical' ? 'border-l-2 border-red-500' : 'border-l-2 border-yellow-500'" class="block w-1 h-full absolute left-0 top-0"/>
        <div class="rounded-none px-3 py-2 bg-white">
            
            <span
                class="block truncate text-base font-bold text-black"
                :title="group.sensorName"
            >
                {{ group.sensorName }}
            </span>
        </div>

        <div class="rounded-none p-2 flex flex-wrap gap-1">
            <span
                v-for="field in group.fields"
                :key="field.data_field"
                class="rounded-none inline-block px-2 py-0.5 text-[10px] font-semibold border"
                :class="type === 'critical'
                    ? 'bg-red-100 text-red-700 border-red-100'
                    : 'bg-yellow-100 text-yellow-800 border-yellow-200'"
            >
                {{ field.data_field }}
            </span>
        </div>
    </div>
</template>
